/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SaveScheduleAdjustmentDefaultCalendarsInput = {
  ScheduleAdjustmentDefaultCalendars: Array<ScheduleAdjustmentDefaultCalendarInput>;
};

export type ScheduleAdjustmentDefaultCalendarInput = {
  CalendarGUID: string | number;
  ScheduleAdjustmentVariant: ScheduleAdjustmentVariant;
};

export type ScheduleAdjustmentVariant =
  | 'AUTO_CHAT_REPLY'
  | 'DEFAULT'
  | 'SCENARIO_CHAT';

export type FetchScheduleAdjustmentDefaultCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchScheduleAdjustmentDefaultCalendarsQuery = { scheduleAdjustmentDefaultCalendars: Array<{ CalendarGUID: string, ScheduleAdjustmentVariant: Types.ScheduleAdjustmentVariant }> };

export type SaveScheduleAdjustmentDefaultCalendarsMutationVariables = Exact<{
  input: Types.SaveScheduleAdjustmentDefaultCalendarsInput;
}>;


export type SaveScheduleAdjustmentDefaultCalendarsMutation = { saveScheduleAdjustmentDefaultCalendars: { isSucceeded: boolean } };


export const FetchScheduleAdjustmentDefaultCalendarsDocument = gql`
    query FetchScheduleAdjustmentDefaultCalendars {
  scheduleAdjustmentDefaultCalendars {
    CalendarGUID
    ScheduleAdjustmentVariant
  }
}
    `;

/**
 * __useFetchScheduleAdjustmentDefaultCalendarsQuery__
 *
 * To run a query within a Vue component, call `useFetchScheduleAdjustmentDefaultCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchScheduleAdjustmentDefaultCalendarsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchScheduleAdjustmentDefaultCalendarsQuery();
 */
export function useFetchScheduleAdjustmentDefaultCalendarsQuery(options: VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>(FetchScheduleAdjustmentDefaultCalendarsDocument, {}, options);
}
export function useFetchScheduleAdjustmentDefaultCalendarsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>(FetchScheduleAdjustmentDefaultCalendarsDocument, {}, options);
}
export type FetchScheduleAdjustmentDefaultCalendarsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchScheduleAdjustmentDefaultCalendarsQuery, FetchScheduleAdjustmentDefaultCalendarsQueryVariables>;
export const SaveScheduleAdjustmentDefaultCalendarsDocument = gql`
    mutation SaveScheduleAdjustmentDefaultCalendars($input: SaveScheduleAdjustmentDefaultCalendarsInput!) {
  saveScheduleAdjustmentDefaultCalendars(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useSaveScheduleAdjustmentDefaultCalendarsMutation__
 *
 * To run a mutation, you first call `useSaveScheduleAdjustmentDefaultCalendarsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveScheduleAdjustmentDefaultCalendarsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveScheduleAdjustmentDefaultCalendarsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveScheduleAdjustmentDefaultCalendarsMutation(options: VueApolloComposable.UseMutationOptions<SaveScheduleAdjustmentDefaultCalendarsMutation, SaveScheduleAdjustmentDefaultCalendarsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveScheduleAdjustmentDefaultCalendarsMutation, SaveScheduleAdjustmentDefaultCalendarsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveScheduleAdjustmentDefaultCalendarsMutation, SaveScheduleAdjustmentDefaultCalendarsMutationVariables>(SaveScheduleAdjustmentDefaultCalendarsDocument, options);
}
export type SaveScheduleAdjustmentDefaultCalendarsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveScheduleAdjustmentDefaultCalendarsMutation, SaveScheduleAdjustmentDefaultCalendarsMutationVariables>;